<template>
  <div class="car-home">
      <div class="page-top">
          <div class="bgcolor"></div>
          <div class="elms">
            <div class="search-bar">
              <div class="sc-box" @click="navigateTo('/h5/car/search')">
              <!-- <div class="sc-box"> -->
                  <div class="q-icon"></div>
                  <div class="q-input">精品大众 Golf优惠活动</div>
              </div>
            </div>
            <div class="banner">
                <div class="bnr-box">
                    <swiper class="banner_swiper" ref="bannerSwiper" :options="swiperOption">
                        <swiperSlide v-for="(item,index) in pageBanners" :key="index">
                            <img v-lazy="item.main_img" @click="tapBanner(item)" class="b-pic"/>
                        </swiperSlide>
                        <div class="swiper-pagination" slot="pagination"></div>
                    </swiper>
                    <!-- <img src="https://rs-resource.oss-cn-shanghai.aliyuncs.com/mobile/images/icons/btest.png" class="b-pic"/> -->
                </div>
            </div>
          </div>
      </div>
      <div class="quick-fn">
          <ul class="qc-ls">
              <li @click="navigateTo('/h5/car/quality')">
                <div class="icon-box bc44">
                    <i></i>
                </div>
                <div class="icon-title">
                    <span>质量保障</span>
                </div>
              </li>
              <li @click="navigateTo('/h5/car/process')">
                <div class="icon-box sfed">
                    <i></i>
                </div>
                <div class="icon-title">
                    <span>购车流程</span>
                </div>
              </li>
              <li @click="navigateTo('/h5/car/redpack?channelid=' + pageInfo.PageId + '_2')">
                <div class="icon-box e239">
                    <i></i>
                </div>
                <div class="icon-title">
                    <span>购车优惠</span>
                </div>
              </li>
              <li @click="navigateTo('/h5/car/findCar')">
                <div class="icon-box bb47">
                    <i></i>
                </div>
                <div class="icon-title">
                    <span>帮你找车</span>
                </div>
              </li>
          </ul>
      </div>
      <div class="car-box">
        <h2>推荐</h2>
        <com-rec-car-list enableAutoLoaded/>
      </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import { getUsedCarList } from './api'
import { mapState, mapMutations } from "vuex";
import { MessageBox } from "mint-ui";
import Cookies from "js-cookie";
import ComRecCarList from './components/list/comRecCarList'
import { navigateTo } from './utils'
export default {
  components: {
    swiper,
    swiperSlide,
    ComRecCarList
  },
  props: {},
  data() {
    return {
      swiperOption: {
            autoplay: {
                delay: 2500,
            },
            pagination: {
                el: ".swiper-pagination",
            },
        }
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "userInfo",
    ]),
    pageBanners(){
        if(!this.pageInfo) return []
        if(!this.pageInfo.Extinfo) return []
        const { banners } = this.pageInfo.Extinfo
        return banners || []
    }
  },
  methods: {
    navigateTo
  },
  created() {
    
  },
  mounted() {
    
  }
};
</script>
<style lang="scss" scoped>
    .car-home{
        width: 100%;
        background: #F5F5F5;
        .page-top{
            //height: 5rem;
            position: relative;
            .bgcolor{
                position: absolute;
                width: 100%;
                top: 0rem;
                z-index: 1;
                height: 2.3rem;
                background: #0D89FF;
            }
            .elms{
                position: relative;
                z-index: 2;
            }
            .search-bar{
                padding: 0.1rem 0.3rem;
                .sc-box{
                    height: .6rem;
                    border-radius: .3rem;
                    background: rgba($color: #fff, $alpha: .3);
                    display: flex;
                    align-items: center;
                    .q-icon{
                        margin-left: .2rem;
                        width: .3rem;
                        height: .3rem;
                        background: url('https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/find.png') no-repeat center center;
                        background-size:contain;
                    }
                    .q-input{
                        margin-left: .13rem;
                        font-weight: 100;
                        font-size: .23rem;
                        color:#fff;
                    }
                }
            }
            .banner{
                padding: 0.1rem 0.3rem;
                overflow: hidden;
                .bnr-box{
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-content: center;
                    .b-pic{
                        width: 7rem;
                        height: 2.5rem;
                        //background: red;
                        border-radius: 7px;
                    }
                }
            }
        }
        .quick-fn{
            width: 7rem;
            margin: .3rem;
            padding: .25rem .1rem;
            box-sizing: border-box;
            background: #FFFFFF;
            box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.06);
            border-radius: 5px;
            .qc-ls{
                display: flex;
                li{
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .icon-box{
                        width: 1.1rem;
                        height: 1.1rem;
                        border-radius: .2rem;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        i{
                            display: inline-block;
                            width: .65rem;
                            height: .65rem;
                        }
                    }
                    .icon-title{
                        text-align: center;
                        padding-top: .13rem;
                        span{
                            color: #313131;
                            font-size: .23rem;
                        }
                    }
                    .bc44{
                        background: linear-gradient(0deg, #1FBC44, #49E885);
                        box-shadow: 0px 6px 10px 0px rgba(106, 230, 86, 0.45);
                        i{
                            background: url('https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/qaulity.png') no-repeat center center;
                            background-size: contain;
                        }
                    }
                    .sfed{
                        background: linear-gradient(0deg, #386FED, #74A4F7);
                        box-shadow: 0px 6px 10px 0px rgba(60, 115, 238, 0.45);
                        i{
                            background: url('https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/process.png') no-repeat center center;
                            background-size: contain;
                        }
                    }
                    .e239{
                        background: linear-gradient(0deg, #EC8239, #F1A056);
                        box-shadow: 0px 6px 10px 0px rgba(237, 137, 63, 0.45);
                        i{
                            background: url('https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/redpack.png') no-repeat center center;
                            background-size: contain;
                        }
                    }
                    .bb47{
                        background: linear-gradient(0deg, #F4BB47, #F5D864);
                        box-shadow: 0px 6px 10px 0px rgba(244, 189, 73, 0.45);
                        i{
                            background: url('https://assets.rurushishi.com/yq-rs-make/car/mobile/images/icons/assisant.png') no-repeat center center;
                            background-size: contain;
                        }
                    }
                }
            }
        }
        .car-box{
            width: 7rem;
            margin: .1rem .3rem;
            background: #FFFFFF;
            box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.06);
            border-radius: 5px;
            h2{
                padding: .3rem .3rem 0rem .2rem;
                font-size: .3rem;
            }
        }
    }
</style>